// extracted by mini-css-extract-plugin
export default {"approvalsPage":"approvals-page--QGQdTL0Ok0NnaRkLUqGb","layoutContainer":"layout-container--X_1LEoV_2rNWCHQj7LWH","loaderContainer":"loader-container--agez73_qLohB18_12d8z"};